import React from "react";
import {
  Box,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  IconButton,
} from "@mui/material";
import { ChevronDownIcon } from "design-system/icons";
import NotificationSettingItem from "./NotificationSettingItem";
import { NotificationSetting } from "types";
import { black } from "design-system/colors";

type NotificationSectionProps = {
  title: string;
  notifications: NotificationSetting[];
  expanded: boolean;
  onExpandChange: (expanded: boolean) => void;
  settingIsDisabledMap: Record<string, boolean>;
};

export const NotificationSection: React.FC<NotificationSectionProps> = ({
  title,
  notifications,
  expanded,
  onExpandChange,
  settingIsDisabledMap,
}) => {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <Card sx={{ mb: 3 }} elevation={2}>
      <CardHeader
        title={
          <Typography variant="h3" sx={{ color: black }}>
            {title}
          </Typography>
        }
        action={
          <IconButton
            onClick={() => onExpandChange(!expanded)}
            sx={{
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <ChevronDownIcon />
          </IconButton>
        }
        sx={{
          cursor: "pointer",
          "& .MuiCardHeader-action": { alignSelf: "center" },
        }}
        onClick={() => onExpandChange(!expanded)}
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <Box display="flex" flexDirection="column" gap={2}>
            {notifications.map((notificationSetting) => (
              <NotificationSettingItem
                key={notificationSetting.id}
                notificationSetting={notificationSetting}
                isDisabled={
                  settingIsDisabledMap[notificationSetting.templateName]
                }
              />
            ))}
          </Box>
        </CardContent>
      </Collapse>
    </Card>
  );
};
